const initialState = {
  empresas: [],       // Asegúrate de que 'empresas' sea un array vacío inicialmente
  empresaSeleccionada: null,
  logoUrl: null       // Inicializa 'logoUrl' con null
  
}

const empresaReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_EMPRESAS':
      //console.log('Datos recibidos en el reducer:', action.data) // Verifica si los datos son correctos
      return {
        ...state,
        empresas: action.data
      }
    case 'GET_EMPRESA':
      return {
        ...state,
        empresa: action.data
      }
    case 'CREATE_EMPRESA':
      return {
        ...state,
        empresas: [...state.empresas, action.data]
      }
      case 'EDIT_EMPRESA':
  return {
    ...state,
    empresas: state.empresas.map((empresa) => {
      if (empresa.id === action.empresa.id) {
        return action.empresa // Si la empresa tiene el mismo id, se actualiza
      }
      return empresa // Si no, se deja igual
    }),
    empresaSeleccionada: action.empresa  // Si tienes una empresa seleccionada
  }
    case 'DELETE_EMPRESA':
      return {
        ...state,
        empresas: state.empresas.filter(empresa => empresa.id !== action.id)
      }
    case 'GET_LOGO_SUCCESS': // Agrega este caso para manejar la URL del logo
      //console.log('Logo URL recibido en el reducer:', action.payload) // Verifica si la URL es correcta
      return {
        ...state,
        logoUrl: action.payload // Asigna la URL del logo al estado logoUrl
      }
      case 'UPLOAD_LOGO_SUCCESS':
      return {
        ...state,
        logoUrl: action.payload
      }
    default:
      return state
  }
}

export default empresaReducer
